import { render, staticRenderFns } from "./merchantNet.vue?vue&type=template&id=35ff5f78&scoped=true&"
import script from "./merchantNet.vue?vue&type=script&lang=js&"
export * from "./merchantNet.vue?vue&type=script&lang=js&"
import style0 from "./merchantNet.vue?vue&type=style&index=0&id=35ff5f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff5f78",
  null
  
)

export default component.exports